
import React, { useState } from 'react';
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface ParkingLocationMapProps {
  address: string | null;
  lat: number | null;
  lng: number | null;
  onLocationChange?: (location: { address: string; lat: number; lng: number }) => void;
}

const ParkingLocationMap = ({ onLocationChange }: ParkingLocationMapProps) => {
  const [streetName, setStreetName] = useState('');
  const [houseNumber, setHouseNumber] = useState('');
  const [addition, setAddition] = useState('');
  const [postalCode, setPostalCode] = useState('');
  const [city, setCity] = useState('');
  const [country, setCountry] = useState('Nederland');

  const handleChange = () => {
    const fullAddress = `${streetName} ${houseNumber}${addition ? ` ${addition}` : ''}, ${postalCode} ${city}, ${country}`;
    onLocationChange?.({
      address: fullAddress,
      lat: null,
      lng: null
    });
  };

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="streetName">Straatnaam</Label>
          <Input
            id="streetName"
            value={streetName}
            onChange={(e) => {
              setStreetName(e.target.value);
              handleChange();
            }}
            placeholder="Straatnaam"
          />
        </div>

        <div className="grid grid-cols-3 gap-2">
          <div className="col-span-2 space-y-2">
            <Label htmlFor="houseNumber">Nr.</Label>
            <Input
              id="houseNumber"
              value={houseNumber}
              onChange={(e) => {
                setHouseNumber(e.target.value);
                handleChange();
              }}
              placeholder="123"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="addition">Toev.</Label>
            <Input
              id="addition"
              value={addition}
              onChange={(e) => {
                setAddition(e.target.value);
                handleChange();
              }}
              placeholder="A"
            />
          </div>
        </div>

        <div className="space-y-2">
          <Label htmlFor="postalCode">Postcode</Label>
          <Input
            id="postalCode"
            value={postalCode}
            onChange={(e) => {
              setPostalCode(e.target.value);
              handleChange();
            }}
            placeholder="1234 AB"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="city">Stad</Label>
          <Input
            id="city"
            value={city}
            onChange={(e) => {
              setCity(e.target.value);
              handleChange();
            }}
            placeholder="Amsterdam"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="country">Land</Label>
          <Select
            value={country}
            onValueChange={(value) => {
              setCountry(value);
              handleChange();
            }}
          >
            <SelectTrigger id="country">
              <SelectValue placeholder="Selecteer een land" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="Nederland">Nederland</SelectItem>
              <SelectItem value="België">België</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
    </div>
  );
};

export default ParkingLocationMap;
